import AdministratorsApi from '../../core/api/AdministratorsApi'

export const ADMINISTRATOR_RESETTING_PASSWORD = 'ADMINISTRATOR_RESETTING_PASSWORD'
export const ADMINISTRATOR_PASSWORD_RESET = 'ADMINISTRATOR_PASSWORD_RESET'
export const ADMINISTRATOR_SET_EMAIL_ADDRESS = 'ADMINISTRATOR_SET_EMAIL_ADDRESS'

export const resettingPassword = () => ({
  type: ADMINISTRATOR_RESETTING_PASSWORD
})

export const setEmailAddress = (emailAddress) => ({
  type: ADMINISTRATOR_SET_EMAIL_ADDRESS,
  emailAddress: emailAddress
})

export function reset (emailAddress) {
  const api = new AdministratorsApi()
  const request = api.resetPassword(emailAddress)

  return (dispatch) => {
    dispatch(resettingPassword())
    request.then(function (response) {
      dispatch(api.handleResponse(ADMINISTRATOR_PASSWORD_RESET, response))
    })
  }
}
